document.addEventListener('DOMContentLoaded', () => {
  const bundleCards = document.querySelectorAll('.bundle-card');
  const dropdowns = document.querySelectorAll('.bundle-row-dropdown');
  const mobileDropdown = document.querySelector('.bundle-mobile-dropdown');
  const bundleVariants = document.querySelectorAll('.bundle-info.variant-bundle');
  let currentRowId = null; // Variable to track the row of the currently opened dropdown
  let mobileDropdownClose;

  if (mobileDropdown) {
    mobileDropdownClose = document.querySelector(".bundle-mobile-dropdown-close");
  }

  // Function to determine if the screen is mobile
  function isMobile() {
    return window.innerWidth <= 767; // Adjust the width as needed for your design
  }

  bundleCards.forEach((bundleCard) => {
    bundleCard.addEventListener('click', () => {
      // Get product data
      const productId = bundleCard.getAttribute('data-product-id');
      const productTitle = bundleCard.getAttribute('data-product-title');
      const productPrice = bundleCard.getAttribute('data-product-price');
      const productDescription = bundleCard.getAttribute('data-product-description');
      const productEmbed = bundleCard.getAttribute('data-product-embed');
      const productVideo = bundleCard.getAttribute('data-product-video');
      const productImg = bundleCard.getAttribute('data-product-image');

      const mediaType = bundleCard.getAttribute('data-media-type');    // Find the parent bundleGrid of the clicked card
      const bundleGrid = bundleCard.closest('.bundle-grid');
      if (!bundleGrid) return;

      // Get only the cards inside this bundleGrid
      const gridCards = bundleGrid.querySelectorAll('.bundle-card');

      // Calculate row index relative to this grid
      const rowId = Math.floor([...gridCards].indexOf(bundleCard) / 4);

      // Find the dropdown inside the same bundleGrid
      const dropdown = bundleGrid.querySelector(`.bundle-row-dropdown[data-row-id="${rowId}"]`);
      
      if (!dropdown) return;

      if (dropdown){
        const dropdownMedia = dropdown.querySelector(".dropdown-product-media");
        const dropdownContent = dropdown.querySelector('.dropdown-product-details');
        const mobileDropdownMedia = mobileDropdown.querySelector(".mobile-dropdown-product-media");
        const mobileDropdownContent = mobileDropdown.querySelector('.mobile-dropdown-product-details');
        const dropdownClose = dropdown.querySelector(".bundle-dropdown-close");

        // Hide all other dropdowns
        dropdowns.forEach((currentDropdown) => {
          if (currentDropdown !== dropdown) {
            currentDropdown.classList.remove('active');
          }
          
          let currentMedia = currentDropdown.querySelector(".dropdown-product-media");
          if (currentMedia) {
            console.log('has media');
            currentMedia.innerHTML = '';
          }
        });

        if (dropdownClose) {
          dropdownClose.addEventListener('click', function(event) {
            dropdown.classList.remove('active');
            if (dropdownMedia) dropdownMedia.innerHTML = '';
          });
        }

        // Update Dropdown media
        if (productEmbed) {
          dropdownMedia.innerHTML = `${productEmbed}`;
          mobileDropdownMedia.innerHTML = `${productEmbed}`;
        } else if (mediaType == 'image') {
          if (productImg) {
            dropdownMedia.innerHTML = `<img src="${productImg}">`;
            mobileDropdownMedia.innerHTML = `<img src="${productImg}">`;
          }
        } else if (mediaType == 'external_video') {
          if (productVideo) {
            dropdownMedia.innerHTML = `<iframe src="${productVideo}" frameborder="0" allowfullscreen></iframe>`;
            mobileDropdownMedia.innerHTML = `<iframe src="${productVideo}" frameborder="0" allowfullscreen></iframe>`;
          }
        }

        // Update dropdown content
        dropdownContent.innerHTML = `
          <h4>${productTitle}</h4>
          <p><strong>Price:</strong> ${productPrice}</p>
          <div class="bundle-product-description">${productDescription}</div>
        `;

        mobileDropdownContent.innerHTML = `
          <h4>${productTitle}</h4>
          <p><strong>Price:</strong> ${productPrice}</p>
          <div class="bundle-product-description">${productDescription}</div>
        `;

        // Show the correct desktop dropdown
        dropdown.classList.add('active');

        // If on mobile, show the single Dropdown
        if (isMobile()) {
          mobileDropdown.classList.add('active');
        }

        if (mobileDropdownClose) {
          mobileDropdownClose.addEventListener('click', function(event) {
            mobileDropdown.classList.remove('active');
          });
        }

        // Close Dropdown when clicking outside
        document.addEventListener('click', function(event) {
          if (!mobileDropdown.contains(event.target) && !event.target.closest('.bundle-card')) {
            mobileDropdown.classList.remove('active');
          }
        });

        // Optional: If you want to update the behavior when the window is resized
        window.addEventListener('resize', function() {
          if (!isMobile()) {
            // Hide the Dropdown if resizing to desktop
            mobileDropdown.classList.remove('active');
          }
        });

      }
    });
  });

  if (bundleVariants){
    const variantSelectorForm = document.querySelector(".product-form__input");
    const variantSelectorRadios = variantSelectorForm.querySelectorAll("input[type=radio]");

    variantSelectorRadios.forEach((radio, index) => {
      radio.addEventListener("click", () => {
         bundleVariants.forEach((variant, index) => {
            if (variant.dataset.variant == radio.value){
              variant.style.display = "block";
            } else {
              variant.style.display = "none";
            }
         });
      });
    });
  }
});
